import { c as _c } from "react/compiler-runtime";
import { getDocumentUploadVaultKeys } from '@onefootprint/core';
import type { Document, DocumentUpload } from '@onefootprint/request-types/dashboard';
import type { EntityVault } from '@onefootprint/types';
import { useObjectUrl } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { easeInOut, motion } from 'framer-motion';
import Image from 'next/image';
import { ROTATION_CLASS_NAME, type Rotation } from '@/utils/rotation';
type SelfiePreviewProps = {
  document: Document;
  selfie: DocumentUpload;
  vault: EntityVault;
  rotation?: Rotation;
};
const SelfiePreview = t0 => {
  const $ = _c(15);
  const {
    document,
    selfie,
    vault,
    rotation: t1
  } = t0;
  const rotation = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== document || $[1] !== selfie || $[2] !== vault) {
    const keys = getDocumentUploadVaultKeys(document, selfie);
    let t3;
    if ($[4] !== vault) {
      t3 = key => vault[key];
      $[4] = vault;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    t2 = keys.map(t3).find(_temp);
    $[0] = document;
    $[1] = selfie;
    $[2] = vault;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const base64Data = t2 as string;
  const {
    objectUrl
  } = useObjectUrl(base64Data);
  if (!selfie) {
    return null;
  }
  if (!objectUrl) {
    return null;
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      opacity: 0,
      scale: 0.95,
      x: 50
    };
    t4 = {
      opacity: 1,
      scale: 1,
      x: 0
    };
    t5 = {
      opacity: 0,
      scale: 0.95,
      x: 50
    };
    t6 = {
      duration: 0.1,
      ease: easeInOut
    };
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  const t7 = ROTATION_CLASS_NAME[rotation];
  let t8;
  if ($[10] !== t7) {
    t8 = cx("object-cover w-full h-auto", t7);
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== objectUrl || $[13] !== t8) {
    t9 = <motion.div className="flex overflow-hidden fixed right-3 bottom-3 md:bottom-auto md:top-14 self-start rounded shadow-lg z-drawer size-24 md:size-56" initial={t3} animate={t4} exit={t5} transition={t6}><Image className={t8} src={objectUrl} width={600} height={600} alt="selfie preview" data-dd-privacy="mask" /></motion.div>;
    $[12] = objectUrl;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
};
export default SelfiePreview;
function _temp(value) {
  return value != null;
}